import { Roles } from "@/helpers/roles";

export const marketTypeRoutes = [
    {
        path: '',
        name: 'adminMarketTypes',
        component: () => import('@/pages/back/registry/market-types/MarketTypeList.vue'),
        meta: {
            requiresAuth: true,
            roles: [
                Roles.ADMIN,
                Roles.PORTAL_MARKET,
                Roles.MARKET_TYPE_READ
            ],
        },
    },
    {

        path: 'create',
        name: 'adminMarketTypeCreate',
        component: () => import('@/pages/back/registry/market-types/MarketTypeCreate.vue'),
        meta: {
            requiresAuth: true,
            roles: [
                Roles.ADMIN,
                Roles.MARKET_TYPE_CREATE
            ],
        },
    },
    {
        path: 'edit/:code',
        name: 'adminMarketTypeEdit',
        component: () => import('@/pages/back/registry/market-types/MarketTypeEdit.vue'),
        meta: {
            requiresAuth: true,
            roles: [
                Roles.ADMIN,
                Roles.MARKET_TYPE_EDIT
            ],
        },
    },
    {
        path: 'view/:code',
        name: 'adminMarketTypeView',
        component: () => import('@/pages/back/registry/market-types/MarketTypeView.vue'),
        meta: {
            requiresAuth: true,
            roles: [
                Roles.ADMIN,
                Roles.MARKET_TYPE_READ
            ],
        },
    },
];
